import { AwsS3Service as service } from './aws-s3.service';
import * as types from './aws-s3.service.types';

export { service, types };
